import { trackIt } from '@vfde-fe/sails_core';
import { call } from 'redux-saga/effects';
import { TRACKING_INFORMATION, TRACKING_SWITCH_OPTIONS } from '../container/DeviceDetail/constants';
import { Device } from '../container/TradeIn/interface';

/**
 * track insurance
 */
export function* trackInsurance ({insurance, insuranceSelected}) {
    const trackingData = [{
        name: insurance.name,
        type: 'service',
        sku: insurance.id,
        priceMonthly: insurance.price.gross,
        proposition: 1,
    }];

    trackSwitchOption(insuranceSelected, trackingData);
}

/**
 * track trade-in activated
 */
export function* trackTradeInActivated (selectedDeviceId: string, selectedDevice: Device) {
    if (selectedDeviceId) {
        // a device is already/still selected so track selection of that device
        yield call(trackTradeIn, true, selectedDevice);
    } else {
        // switch was activated without a selected device so track trade-in reveal
        yield call(trackTradeInReveal);
    }
}

/**
 * track trade-in deactivated
 */
export function* trackTradeInDeactivated (selectedDeviceId: string, selectedDevice: Device) {
    if (selectedDeviceId) {
        yield call(trackTradeIn, false, selectedDevice);
    }
}

/**
 * track trade-in reveal
 */
export function* trackTradeInReveal () {
    const trackingData = {
        information_action: 'reveal',
        information_name: 'trade-in option',
        information_ui_type: 'overlay',
        information_trigger: 'link',
    };

    trackIt(TRACKING_INFORMATION, trackingData);
}

/**
 * track trade-in
 */
export function* trackTradeIn (isTradeIn: boolean, device: Pick<Device, 'name' | 'formattedPrice'>) {
    const trackingData = [{
        name: `trade in ${device.name}`,
        type: 'discount',
        priceOnce: device.formattedPrice,
        priceMonthly: '15.00',
        proposition: 1,
    }];

    trackSwitchOption(isTradeIn, trackingData);
}

const trackSwitchOption = (switchOptionFlag: boolean, trackingData: any) => {
    const trackingDataKey = switchOptionFlag ? 'selectedOption' : 'removedOption';
    trackIt(TRACKING_SWITCH_OPTIONS, {[trackingDataKey]: trackingData });
};

/**
 * track trade in overlay
 */
export function* trackTradeInOverlay () {
    const trackingData = {
        information_action: 'reveal',
        information_name: 'alles zur inzahlungnahme',
        information_ui_type: 'overlay',
        information_trigger: 'link',
    };

    trackIt(TRACKING_INFORMATION, trackingData);
}
